export default "__VITE_ASSET__D5YLu7dv__"